/** CoStar.Api.MarketAnalytics.SearchMarkets.Common.GeographyType */
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["Submarket"] = 0] = "Submarket";
    GeographyType[GeographyType["SubmarketCluster"] = 1] = "SubmarketCluster";
    GeographyType[GeographyType["CBSA"] = 2] = "CBSA";
    GeographyType[GeographyType["Market"] = 3] = "Market";
    GeographyType[GeographyType["Country"] = 4] = "Country";
    GeographyType[GeographyType["County"] = 5] = "County";
    GeographyType[GeographyType["City"] = 6] = "City";
    GeographyType[GeographyType["NationalMajor"] = 7] = "NationalMajor";
    GeographyType[GeographyType["Region"] = 8] = "Region";
    GeographyType[GeographyType["State"] = 9] = "State";
    GeographyType[GeographyType["PostalCode"] = 10] = "PostalCode";
    GeographyType[GeographyType["UKPostalCodeDistrict"] = 12] = "UKPostalCodeDistrict";
    GeographyType[GeographyType["UKCounty"] = 13] = "UKCounty";
    GeographyType[GeographyType["USPostalCode"] = 16] = "USPostalCode";
    GeographyType[GeographyType["ForwardSortation"] = 18] = "ForwardSortation";
    GeographyType[GeographyType["College"] = 20] = "College";
    GeographyType[GeographyType["USBlockgroup"] = 21] = "USBlockgroup";
    GeographyType[GeographyType["UKOutputArea"] = 22] = "UKOutputArea";
    GeographyType[GeographyType["CADisseminationArea"] = 23] = "CADisseminationArea";
    GeographyType[GeographyType["USCensus"] = 24] = "USCensus";
    GeographyType[GeographyType["CoStarProductMarket"] = 31] = "CoStarProductMarket";
    GeographyType[GeographyType["EnterpriseCountry"] = 37] = "EnterpriseCountry";
})(GeographyType || (GeographyType = {}));
